<template>
    <div class="login-page">
        <p class="err" v-if="lastError">{{lastError}}</p>
        <h3>Enter your login</h3>
        <div class="form">
            <form class="login-form">
                <input type="text" placeholder="username" v-model="username"/>
                <input type="password" placeholder="password" v-model="password"/>
                <button type="button" @click="login">login</button>
            </form>
            <div class="overlay" v-if="loading  "></div>
            <div class="loading" v-if="loading ">
                <sync-icon style="font-size: 80px; color: white"/>
            </div>
        </div>
        <p class="ver">{{env}}</p>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import SyncIcon from "vue-material-design-icons/sync"

    export default {
        data() {
            return {
                username: '',
                password: '',
                lastError: '',
                loading: false
            }
        },
        components: {
            SyncIcon
        },
        computed: {
            ...mapState(['token']),
            env() {
                return process.env.NODE_ENV
            }
        },
        methods: {
            login: function () {
                this.loading = true;
                this.$store.dispatch('login', {u: this.username, p: this.password})
                    .then(() => {
                        this.$router.replace('/');
                    })
                    .catch((e) => {
                        this.lastError = e;
                    })
                    .finally(() => {
                        this.loading = false
                    });
            }
        },
        mounted() {
            if (this.token) {
                this.$router.replace('/');
            }
        }

    }
</script>


<style scoped>
    H3 {
        text-align: center
    }
    .err { text-align: center; background-color: #fee; font-size: 15px; padding: 10px; margin: 20px auto; border: solid 1px red; color: red;  text-transform: uppercase }
    .login-page {
        width: 360px;
        padding: 8% 0 0;
        margin: auto;
    }

    .form {
        position: relative;
        z-index: 1;
        background: #FFFFFF;
        max-width: 360px;
        margin: 0 auto 100px;
        padding: 45px;
        text-align: center;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
    }

    .form input {
        outline: 0;
        background: #f2f2f2;
        width: 100%;
        border: 0;
        margin: 0 0 15px;
        padding: 15px;
        box-sizing: border-box;
        font-size: 14px;
    }

    .form button {
        text-transform: uppercase;
        outline: 0;
        background: #009439;
        width: 100%;
        border: 0;
        padding: 15px;
        color: #FFFFFF;
        font-size: 14px;
        -webkit-transition: all 0.3 ease;
        transition: all 0.3 ease;
        cursor: pointer;
        border-radius: 5px;
    }

    .form button:hover, .form button:active, .form button:focus {
        background: #43A047;
    }

    .ver {
        text-align: center;
        color: #ccc
    }

    .loading {
        padding-top: 25%
    }
</style>